
const features = [
  { name: "SALE'S CRM", link: "/crm-feature-section" },
  { name: "CORE ERP", link: "/erp-feature-section" },
  { name: "Payroll Management", link: "/payroll-management" },
  { name: "Inventory Management", link: "/inventory-management" },
  { name: "Project Management", link: "/project-management" },
  { name: "Production", link: "/production" },
  { name: "Process Management", link: "/process-management" },
  { name: "Menufecturing", link: "/menufecturing-management" },
  { name: "AMC & CMC", link: "/cloud-solutions" },
  { name: "Accounting", link: "/account-management" },
];

export default features;
